import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Router} from '@angular/router';
import { ProgressBarModule } from 'primeng/primeng';
import {ProgressService} from './shared/service/progress.service';
import {Subscription} from 'rxjs/Subscription';
import {AuthService} from "./shared/service/auth.service";
import {GlobalService} from "./shared/service/global.service";
import {LookupService} from "./shared/service/lookupService";

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  templateUrl: './app.component.html'
})

export class App {

  loading:boolean;
  subscription:Subscription;

  profileDisplay:boolean = false;

  constructor(private proService:ProgressService, private router:Router, private globalService:GlobalService, private auth: AuthService, private lookupService: LookupService) {
    this.subscription = this.proService.getProgress().subscribe(loading => this.loading = loading);
    this.globalService.subscribe('profile-display', status => this.profileDisplay = status);
    this.lookupService.loadLookups();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/app.component.ts